import { render, staticRenderFns } from "./MenuFooter.vue?vue&type=template&id=e5c04a10&scoped=true"
import script from "./MenuFooter.vue?vue&type=script&lang=js"
export * from "./MenuFooter.vue?vue&type=script&lang=js"
import style0 from "./MenuFooter.vue?vue&type=style&index=0&id=e5c04a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c04a10",
  null
  
)

export default component.exports